<template>
  <v-chip :input-value="lang.locale" :value="lang.locale" :color="color" text-color="white" class="select-chip">
    <div class="select-chip-flag"><img
      :src="formattedImgUrl(lang)"
      width="24"
      @error="onImgError"
    ></div>
    <span :class="colorText" class="select-chip-locale">{{ lang.fullName || lang.locale }}</span>
  </v-chip>
</template>

<script>
  import { BASE_FLAG_URL, DEFAULT_FLAG } from './mapperIsoLocale'

  export default {
    name: 'LangChip',
    props: {
      lang: Object,
      color: String,
      colorText: String,
    },
    methods: {
      onImgError (e) {
        e.target.src = `${BASE_FLAG_URL}${DEFAULT_FLAG}.svg`
      },
      formattedImgUrl (lang) {
        const flag = lang.urlFlag

        return `${BASE_FLAG_URL}${flag}.svg`
      }
    }
  }
</script>

<style scoped lang="scss">
  .select-chip {
    width: 85px;
    display: flex;
    padding: 4px;
    align-items: center;
    cursor: pointer;

    & ::v-deep .v-chip__content {
      display: flex;
      gap: 4px;
    }

    &-locale {
      font-size: 13px;
      //color: rgba(0, 0, 0, 0.87);
      font-weight: 400;
    }

    &-flag {
      display: flex;
      align-items: center;
    }
  }
</style>
